import _extends from "@babel/runtime/helpers/esm/extends";
import { CustomEvent } from '@deezer/event-target';
// The enum of event types for this “namespace” (do not export, see below)
var Events = /*#__PURE__*/function (Events) {
  Events["SHARE"] = "share";
  Events["UPDATE_VIEW_STATE"] = "updateViewState";
  Events["CLOSE_SCREEN"] = "closeScreen";
  Events["PLAY_AUDIO"] = "playAudio";
  Events["STOP_AUDIO"] = "stopAudio";
  Events["MUTE_AUDIO"] = "muteAudio";
  Events["ON_PAGE_CHANGED"] = "onPageChanged";
  Events["OPEN_DEEP_LINK"] = "openDeepLink";
  Events["SEND_CAST_MESSAGE"] = "sendCastMessage";
  Events["SHOW_CAST_ICON"] = "showCastIcon";
  Events["HIDE_CAST_ICON"] = "hideCastIcon";
  Events["OPEN_CAST_DIALOG"] = "openCastDialog";
  return Events;
}(Events || {}); // This is necessary so we can “extends” the enum later
// This will be the enum to use accross the application
export const BridgeEvents = _extends({}, Events);

// This is the mapping between BridgeEvent (enum) and BridgeEvent (class)

export default class BridgeEvent extends CustomEvent {}
//# sourceMappingURL=events.js.map